/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DialogWithImage } from 'components/modals'
import { Form } from '@entrata/portals-common/lib/components/forms'
import { EmailField } from '@entrata/portals-common/lib/standard-fields'
import { Btn } from 'components/buttons'
import { navigate } from 'gatsby'
import styled from '@emotion/styled'


const images = {
  small: 'man_hands_using_laptop-550.jpg',
  large: 'man_hands_using_laptop.jpg',
}
const StyledWrapperDiv = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: baseline;
  margin-top: 43px;

  @media only screen and (min-width: 526px) {
    justify-content: left;
    margin-top: 0;
  }
`
const StyledA = styled('a')`
  width: 200px;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.secondary.base};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.light};
  font-size: 18px;
  padding: 2px 8px 2px 8px;
  margin-top: 24px;
  text-align: center;
  text-decoration: none;

  @media only screen and (min-width: 526px) {
    margin-top: 0;
    font-size: 16px;
  }
`
class RetrieveQuoteDialog extends Component {
  handleSubmit = ({ values }) => {
    // TO DO :: figure out what this should actually do
    navigate(`/quote?saved-email=${values.email}`)
  }

  render() {
    return (
      <DialogWithImage
        sources={images}
        title="Let's see where you left off."
        {...this.props}
      >
        <Form
          initialFieldState={{ email: { required: true } }}
          onSubmit={this.handleSubmit}
        >
          <Form.Field name='email'>
            {props => <EmailField {...props} label='Email' />}
          </Form.Field>

          <Form.Actions
            render={({ hasErrors }) => (
              <StyledWrapperDiv>
                <Btn appearance='primary' disabled={hasErrors} type='submit'>
                  Retrieve Quote
                </Btn>
                <StyledA onClick={this.props.onClose}>Nevermind</StyledA>
              </StyledWrapperDiv>
            )}
          />
        </Form>
      </DialogWithImage>
    )
  }
}

RetrieveQuoteDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
}

export default RetrieveQuoteDialog
